/**
 * Created by lihanying on 2017/7/6.
 */
import { GETCLUBSHIFTLIST, GETPERIOD } from './constants'

const initState = { shiftList: [] }

export default function (state = initState, action) {
  switch (action.type) {
    case GETCLUBSHIFTLIST:
      return Object.assign({}, state, { shiftList: action.payload })

    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })


    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/ClubShift/reduce.js